import { render, staticRenderFns } from "./TreatmentCourseEditor.vue?vue&type=template&id=4441592c&"
import script from "./TreatmentCourseEditor.vue?vue&type=script&lang=ts&"
export * from "./TreatmentCourseEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports